import { render, staticRenderFns } from "./DispatchFormBase.vue?vue&type=template&id=a570d02c"
import script from "./DispatchFormBase.vue?vue&type=script&lang=js"
export * from "./DispatchFormBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports